import { PageRef } from 'providers/page-ref';
import { FitnessPlan } from '@cf-shared/data-model/fitness-plan';

export type WorkoutDetailPageParams = {
  id?: string;
  date?: string;
  returnCallback?: string;
  local?: {
    plan?: FitnessPlan;
  };
};

export type WorkoutDetailPageResult = {
  workoutModified?: boolean;
};

export const IWorkoutDetailPage: PageRef<WorkoutDetailPageParams, WorkoutDetailPageResult> = {
  pageName: 'WorkoutDetailPage',
} as PageRef<WorkoutDetailPageParams, WorkoutDetailPageResult>;
